import type { PropsWithChildren } from 'react';
import { withAuthenticationRequired } from './withAuthenticationRequired';

export const Protected: React.FC<PropsWithChildren> =
  withAuthenticationRequired((props) => props.children);
